import axios from 'axios';
import { api } from './api';

export interface PermissionData {
  id: number;
  data: {
    name: string;
    codename: string;
    content_type: string;
  };
}

export const permissionService = {
  
  getPermissionsList: async (): Promise<PermissionData[]> => {
    try {
      const response = await api.get('/permission/list');
      return response.data;
    } catch (error) {
      console.error('Error al obtener lista de permisos:', error);
      
      if (axios.isAxiosError(error)) {
        throw new Error(error.response?.data?.error || 'Error al comunicarse con el servidor');
      }
      
      throw new Error('Error inesperado al obtener la lista de permisos');
    }
  }
};
